import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MyserviceService } from '../../provider/myservice.service';
import {invoice_lange} from "../../language/invoice";
import * as moment from 'moment';
import { DatatableComponent } from "@swimlane/ngx-datatable";

@Component({
  selector: 'app-invoice-ngx-table',
  templateUrl: './invoice-ngx-table.component.html',
  styleUrls: ['./invoice-ngx-table.component.scss']
})
export class InvoiceNgxTableComponent implements OnInit {
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  loadingIndicator=true;
  reorderable: boolean = true;
  invoices:any;
  all_invoices:any;
  timeout: any;

  columns = [
    { prop: 'bill_id' },
    { name: 'fee_id' },
    { name: 'fee_description' }
  ];

  @ViewChild(DatatableComponent, {static: false,read:true}) table: DatatableComponent;

  constructor(private route:ActivatedRoute,router:Router,private service:MyserviceService) { }

  ngOnInit() {
    this.refreshData();
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=invoice_lange[this.lang];
      }else{
        this.language=invoice_lange[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
  }

  refreshData(){
    this.loadingIndicator=true;
    this.service.postData({},"invoice/get-invoice").then((result:any)=>
    {
      this.loadingIndicator=false;
      this.all_invoices=result.data.filter((item)=>{
        var res:any;
        res=item;
        res.createDate=moment(item.create_datetime).format("DD/MM/YYYY");
        res.dueDate=moment(new Date(item.due_date)).format("DD/MM/YYYY");
        res.check=false;
        res.address_EN=item.place_address+' '+item["tambon_en"]+' '+item["amphur_en"]+' '+item["province_en"];
        res.address_TH=item.place_address+' '+item["tambon_th"]+' '+item["amphur_th"]+' '+item["province_th"];
        return res;
      });

      for(const row of this.all_invoices) {
        row.height = Math.floor(Math.random() * 80) + 50;
      }
     
      this.invoices=this.all_invoices;
    },(err)=>
    {
    })
  }

  getRowHeight(row) {
    return row.height;
  }

  onPage(event) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      console.log('paged!', event);
    }, 100);
  }

}
